import styled from "styled-components";

export const Wrapper = styled.section`
  height: 100vh;
  
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  gap: 1em;
`;
